import ConnectWalletButton from "./ConnectWalletButton";

export default ConnectWalletButton;
